import { useEffect } from 'react'
import USBModal from '@usb-shield/react-modal'
import PropTypes from 'prop-types'
import './modalStyle.scss'

const ModalWrapper = (props) => {
  const { children, addClasses, ...rest } = props
  const overLayRemover = () => {
    const modalOverlayDiv = document.querySelector('.usb-modal-v2--overlay')
    if (modalOverlayDiv?.classList?.contains('usb-modal-v2--visible')) {
      modalOverlayDiv?.classList?.remove('usb-modal-v2--visible')
    }
  }
  useEffect(
    () => () => {
      overLayRemover()
      // console.log('removeOverlay')
    },
    []
  )
  return (
    <USBModal addClasses={`${addClasses} wrapper-modal-addedclass`} {...rest}>
      {children}
    </USBModal>
  )
}

ModalWrapper.propTypes = {
  addClasses: PropTypes.string,
  // eslint-disable-next-line  react/forbid-prop-types
  children: PropTypes.element.isRequired
}
ModalWrapper.defaultProps = {
  addClasses: ''
}

export default ModalWrapper
